module.exports = __webpack_public_path__ + "img/desktop/Background/background_illuminated@3x.jpg?0.0.53";